import React from 'react';
import { useEffect } from 'react';
import Layout from '../components/Layout';

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#2A382A] via-[#2A382A] to-[#1F2B1F] pt-32 pb-16">
        <div className="container max-w-4xl mx-auto px-4 md:px-8">
          <div className="bg-[#1F2B1F]/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 shadow-xl border border-white/10">
            <h1 className="font-barrio text-4xl md:text-5xl mb-4 text-white">Privacy Policy</h1>
          
            <p className="text-sm text-white/50 mb-8">Last updated: January 4, 2025</p>
            
            <div className="legal-content">
              <p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>

              <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>

              <h2>Types of Data Collected</h2>
              <h3>Personal Data</h3>
              <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
              <ul>
                <li>Email address</li>
                <li>First name and last name</li>
                <li>Phone number</li>
                <li>Address, State, Province, ZIP/Postal code, City</li>
              </ul>

              <h3>Usage Data</h3>
              <p>Usage Data is collected automatically when using the Service.</p>
              <p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>

              <h2>Use of Your Personal Data</h2>
              <p>The Company may use Personal Data for the following purposes:</p>
              <ul>
                <li>To provide and maintain our Service</li>
                <li>To manage Your Account</li>
                <li>For the performance of a contract</li>
                <li>To contact You</li>
                <li>To provide You with news, special offers and general information</li>
                <li>To manage Your requests</li>
              </ul>

              <h2>Retention of Your Personal Data</h2>
              <p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>

              <h2>Transfer of Your Personal Data</h2>
              <p>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p>

              <h2>Delete Your Personal Data</h2>
              <p>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</p>
              <p>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</p>

              <h2>Disclosure of Your Personal Data</h2>
              <h3>Business Transactions</h3>
              <p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>

              <h3>Law enforcement</h3>
              <p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>

              <h2>Security of Your Personal Data</h2>
              <p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>

              <h2>Children's Privacy</h2>
              <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13.</p>

              <h2>Changes to this Privacy Policy</h2>
              <p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>
              <p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.</p>

              <h2>Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, you can contact us by email: privacy@sierpefrogs.com</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;